import React from 'react';
import { Drawer } from 'antd';
import closeIcon from '../../../assets/images/close.svg';
import {popup_close as closebtn} from '../../../assets/images'

const CustomDrawer = ({
  visible,
  title,
  subHeaderStyle,
  headerStyle,
  width,
  close,
  body,
}) => {
  return (
    <Drawer
      title={
        <div style={subHeaderStyle}>
          {title}
          <img
            src={closebtn}
            alt='close-icon'
            onClick={close}
            style={{ cursor: 'pointer', height: '32px' }}
          />
        </div>
      }
      visible={visible}
      width={width}
      headerStyle={headerStyle}
      onClose={close}
      drawerStyle={{'overflow-x': 'hidden'}}
      className='help-drawer-xs'
    >
      {body}
    </Drawer>
  );
};

export default CustomDrawer;
